module.exports = __webpack_public_path__ + "static/img/ramp-8m-x-1m_256.12cd919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ramp-8m-x-1m_256.png
// module id = yHtb
// module chunks = 0